import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row, Col, Image } from 'antd';
import { getChildrenToRender } from '../../utils';
import { isImg } from '../../utils';
import './footer.less'
import mapContainer from './../../components/Map'
import { FacebookOutlined, LinkedinOutlined, YoutubeOutlined } from '@ant-design/icons';
import { enquireScreen } from 'enquire-js';
let isMobile;
enquireScreen((b) => {
    isMobile = b;
});
class Footer extends React.Component {
  state = {
    isMobile,
  };
  static defaultProps = {
    className: 'footer1',
  };
  componentDidMount() {
    this.map = new mapContainer('map')
  }

  getLiChildren = (data) =>
    data.map((item, i) => {
      const { title, childWrapper, ...itemProps } = item;
      return (
        <Col key={i.toString()} {...itemProps} title={null} content={null}>
          <h2 {...title}>
            {typeof title.children === 'string' &&
              title.children.match(isImg) ? (
              <img src={title.children} width="100%" alt="img" style={{ marginBottom: 20 }} />
            ) : (
              title.children
            )}
          </h2>
          <div {...childWrapper}>
            {childWrapper.children.map(getChildrenToRender)}
          </div>
        </Col>
      );
    });
    
  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const childrenToRender = this.getLiChildren(dataSource.block.children);
    const iconStyle = {
      fontSize: 22,
      color:"#999",
      margin:"0 6px 0 6px"
    }
    return (
      <div {...props} {...dataSource.wrapper}>
        <Row className='footer-box'>
          <Col span="18">
            <QueueAnim
              type="bottom"
              key="ul"
              leaveReverse
              component={Row}
              {...dataSource.block}
            >
              {childrenToRender}
            </QueueAnim>
          </Col>
          <Col xs={24} md={6} className='map-box'>
            <div id='map' style={{ width: 350, height: 240 }}>
              <div id="popup" className="ol-popup" >
                <div id="popup-content">
                  <div className='title'>中国成都市锦江区蓝顶艺术区二期50栋-2</div>
                  {/* <Row>
                    <Col span="6">
                      <Image preview={false} src="http://qiniu.metridynamic.com/image/logo/logo.png" />
                    </Col>
                    <Col xs={24} md={16}>
                      <div>Address：Building 50, Chengdu Landing contemporary art base</div>
                      <div>Email:frank.l@metridynamic.com</div>
                    </Col>
                  </Row> */}
                </div>
              </div>
            </div>
          </Col>
         

        </Row>
        <div style={{ display: "flex",justifyContent:"center",alignItems:"center",paddingTop:12 }}>
            <p>
              <a href="https://www.facebook.com/MetriDynamic" style={{ color: "#000" }}>
                <FacebookOutlined style={iconStyle} />
              </a>

              <a href="https://www.youtube.com/channel/UCPjNc3YV3Pq6oyYCiEd76aQ" style={{ color: "#000" }}>
                <YoutubeOutlined style={iconStyle} />
              </a>

              <a href="https://www.linkedin.com/company/metridynamic" style={{ color: "#000" }}>
                <LinkedinOutlined style={iconStyle} />
              </a>
            </p>
          </div>

          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from' }}
            key="copyright"
            {...dataSource.copyrightWrapper}
          >
            <div {...dataSource.copyrightPage}>
              <div {...dataSource.copyright}>
                {window.location.hostname==="metri.cn"||window.location.hostname==="www.metri.cn"?dataSource.copyright.children1:dataSource.copyright.children}
              </div>
            </div>
          </TweenOne>
      </div>
    );
  }
}

export default Footer;
